class ToolTip {
    constructor(DOMelement) {
        try {
            this.el = DOMelement;
            this.parent = this.el.parentNode;
            this.toggleToolTip = this.toggleToolTip.bind(this);
            this.toggleToolTip();
        } catch (error) {
            console.log(error);
        }       
    }

    toggleToolTip() {
        ['mouseover', 'click'].forEach(e => {
            this.parent.addEventListener(e, function() {     
                let toolTipHeight = this.querySelector('.sd-tooltip--default').clientHeight;          
                this.querySelector('.sd-tooltip--default').style.top = -toolTipHeight + "px";
                this.querySelector('.sd-tooltip--default').classList.add("sd-tooltip--show");
            });
        })
        this.parent.addEventListener('mouseout', function() {
            this.querySelector('.sd-tooltip--default').classList.remove("sd-tooltip--show");
        });
    }
}

export default ToolTip;